let config = {
	TOKEN_KEY: 'token', // 存储token的key
  BASE_URL: process.env.BASE_URL, // 数据请求地址
  publicPramasType: 'headers', // 公用传参的入参位置 headers | body
	api: {
    origin: "http://api.tvsvod.com/", // 正式
  } // 接口请求地址
}
export default config